(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  Array.prototype.forEach.call(document.querySelectorAll('[data-cdi-dv-addons]'), function (wrap) {
    if (wrap.dataset.cdiInit) return;
    wrap.dataset.cdiInit = '1';

    var rail = wrap.querySelector('[data-cdi-dv-addons-rail]');
    if (!rail) return;

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      wrap.classList.toggle('has-more-start', max > 2 && rail.scrollLeft > 2);
      wrap.classList.toggle('has-more-end', max > 2 && rail.scrollLeft < max - 2);
    }

    function step(dir) {
      var card = rail.querySelector('.cdi-dv-addons__card');
      if (!card) return;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      rail.scrollBy({ left: dir * (card.getBoundingClientRect().width + gap), behavior: reduce.matches ? 'auto' : 'smooth' });
    }

    wrap.addEventListener('click', function (e) {
      if (e.target.closest('[data-cdi-dv-addons-prev]')) step(-1);
      else if (e.target.closest('[data-cdi-dv-addons-next]')) step(1);
    });

    var ticking = false;
    rail.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; sync(); });
    }, { passive: true });

    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(rail);
    sync();
  });
})();
